import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthorizeService } from './authorize.service';

export const authorizeInterceptor: HttpInterceptorFn = (req, next) => {
  const authorizeService = inject(AuthorizeService);
  const token = authorizeService.getAccessToken();
  // An explicitly-set header wins (e.g. the silent-refresh call carries the
  // refresh token itself).
  if (token && !req.headers.has('Authorization')) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }
  return next(req);
};